import type { PropsWithChildren } from "react";
import { usePortfolioNavigationSections } from "@/components/sidebar/portfolio-sidebar-items";
import type { PortfolioTab } from "@/lib/schema";
import { Layout } from "./layout";

export const PortfolioLayout = ({ page, children }: { page: PortfolioTab } & PropsWithChildren) => {
  const sections = usePortfolioNavigationSections();
  return (
    <Layout activeTab={page} sections={sections}>
      {children}
    </Layout>
  );
};
